import { createContext } from 'react';
import type { FormFields } from '../../components/page/page.schema';

export type PageRevisionUpdatesContextType = {
  updates: FormFields;
  setUpdates: (updates: FormFields | ((prev: FormFields) => FormFields)) => void;
  hasUnsavedChanges: boolean;
};

export const PageRevisionUpdatesContext = createContext<PageRevisionUpdatesContextType | undefined>(undefined);
